function EmptyComponent() {
  return <div>No merchants to display</div>;
}

export default EmptyComponent;
